export const winnerLabels = [
  { single: '🥇', label: '🥇st' },
  { single: '🥈', label: '🥈st' },
  { single: '🥉', label: '🥉rd' },
]
